export default __webpack_public_path__ + "static/media/microsoft.3a8a8d3d.png";